module.exports = __webpack_public_path__ + "static/reg1-c4c878bd1adebbd515e828fdb06f8ed6.png";